// @generated by protoc-gen-es v1.6.0 with parameter "target=ts"
// @generated from file cometbft/types/v1/params.proto (package cometbft.types.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Duration, Int64Value, Message, proto3, protoInt64 } from "@bufbuild/protobuf";

/**
 * ConsensusParams contains consensus critical parameters that determine the
 * validity of blocks.
 *
 * @generated from message cometbft.types.v1.ConsensusParams
 */
export class ConsensusParams extends Message<ConsensusParams> {
  /**
   * @generated from field: cometbft.types.v1.BlockParams block = 1;
   */
  block?: BlockParams;

  /**
   * @generated from field: cometbft.types.v1.EvidenceParams evidence = 2;
   */
  evidence?: EvidenceParams;

  /**
   * @generated from field: cometbft.types.v1.ValidatorParams validator = 3;
   */
  validator?: ValidatorParams;

  /**
   * @generated from field: cometbft.types.v1.VersionParams version = 4;
   */
  version?: VersionParams;

  /**
   * Use FeatureParams.vote_extensions_enable_height instead
   *
   * @generated from field: cometbft.types.v1.ABCIParams abci = 5 [deprecated = true];
   * @deprecated
   */
  abci?: ABCIParams;

  /**
   * @generated from field: cometbft.types.v1.SynchronyParams synchrony = 6;
   */
  synchrony?: SynchronyParams;

  /**
   * @generated from field: cometbft.types.v1.FeatureParams feature = 7;
   */
  feature?: FeatureParams;

  constructor(data?: PartialMessage<ConsensusParams>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.types.v1.ConsensusParams";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "block", kind: "message", T: BlockParams },
    { no: 2, name: "evidence", kind: "message", T: EvidenceParams },
    { no: 3, name: "validator", kind: "message", T: ValidatorParams },
    { no: 4, name: "version", kind: "message", T: VersionParams },
    { no: 5, name: "abci", kind: "message", T: ABCIParams },
    { no: 6, name: "synchrony", kind: "message", T: SynchronyParams },
    { no: 7, name: "feature", kind: "message", T: FeatureParams },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ConsensusParams {
    return new ConsensusParams().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ConsensusParams {
    return new ConsensusParams().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ConsensusParams {
    return new ConsensusParams().fromJsonString(jsonString, options);
  }

  static equals(a: ConsensusParams | PlainMessage<ConsensusParams> | undefined, b: ConsensusParams | PlainMessage<ConsensusParams> | undefined): boolean {
    return proto3.util.equals(ConsensusParams, a, b);
  }
}

/**
 * BlockParams define limits on the block size and gas.
 *
 * @generated from message cometbft.types.v1.BlockParams
 */
export class BlockParams extends Message<BlockParams> {
  /**
   * Maximum size of a block, in bytes.
   *
   * Must be greater or equal to -1 and cannot be greater than the hard-coded
   * maximum block size, which is 100MB.
   *
   * If set to -1, the limit is the hard-coded maximum block size.
   *
   * @generated from field: int64 max_bytes = 1;
   */
  maxBytes = protoInt64.zero;

  /**
   * Maximum gas wanted by transactions included in a block.
   *
   * Must be greater or equal to -1. If set to -1, no limit is enforced.
   *
   * @generated from field: int64 max_gas = 2;
   */
  maxGas = protoInt64.zero;

  constructor(data?: PartialMessage<BlockParams>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.types.v1.BlockParams";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "max_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "max_gas", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BlockParams {
    return new BlockParams().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BlockParams {
    return new BlockParams().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BlockParams {
    return new BlockParams().fromJsonString(jsonString, options);
  }

  static equals(a: BlockParams | PlainMessage<BlockParams> | undefined, b: BlockParams | PlainMessage<BlockParams> | undefined): boolean {
    return proto3.util.equals(BlockParams, a, b);
  }
}

/**
 * EvidenceParams determine the validity of evidences of Byzantine behavior.
 *
 * @generated from message cometbft.types.v1.EvidenceParams
 */
export class EvidenceParams extends Message<EvidenceParams> {
  /**
   * Maximum age of evidence, in blocks.
   *
   * The recommended formula for calculating it is max_age_duration / {average
   * block time}.
   *
   * @generated from field: int64 max_age_num_blocks = 1;
   */
  maxAgeNumBlocks = protoInt64.zero;

  /**
   * Maximum age of evidence, in time.
   *
   * The recommended value of is should correspond to the application's
   * "unbonding period" or other similar mechanism for handling
   * Nothing-At-Stake attacks.
   * See: https://github.com/ethereum/wiki/wiki/Proof-of-Stake-FAQ#what-is-the-nothing-at-stake-problem-and-how-can-it-be-fixed.
   *
   * @generated from field: google.protobuf.Duration max_age_duration = 2;
   */
  maxAgeDuration?: Duration;

  /**
   * Maximum size in bytes of evidence allowed to be included in a block.
   *
   * It should fall comfortably under the maximum size of a block.
   *
   * @generated from field: int64 max_bytes = 3;
   */
  maxBytes = protoInt64.zero;

  constructor(data?: PartialMessage<EvidenceParams>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.types.v1.EvidenceParams";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "max_age_num_blocks", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "max_age_duration", kind: "message", T: Duration },
    { no: 3, name: "max_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EvidenceParams {
    return new EvidenceParams().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EvidenceParams {
    return new EvidenceParams().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EvidenceParams {
    return new EvidenceParams().fromJsonString(jsonString, options);
  }

  static equals(a: EvidenceParams | PlainMessage<EvidenceParams> | undefined, b: EvidenceParams | PlainMessage<EvidenceParams> | undefined): boolean {
    return proto3.util.equals(EvidenceParams, a, b);
  }
}

/**
 * ValidatorParams restrict the public key types validators can use.
 *
 * NOTE: uses ABCI public keys naming, not Amino names.
 *
 * @generated from message cometbft.types.v1.ValidatorParams
 */
export class ValidatorParams extends Message<ValidatorParams> {
  /**
   * @generated from field: repeated string pub_key_types = 1;
   */
  pubKeyTypes: string[] = [];

  constructor(data?: PartialMessage<ValidatorParams>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.types.v1.ValidatorParams";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "pub_key_types", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidatorParams {
    return new ValidatorParams().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidatorParams {
    return new ValidatorParams().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidatorParams {
    return new ValidatorParams().fromJsonString(jsonString, options);
  }

  static equals(a: ValidatorParams | PlainMessage<ValidatorParams> | undefined, b: ValidatorParams | PlainMessage<ValidatorParams> | undefined): boolean {
    return proto3.util.equals(ValidatorParams, a, b);
  }
}

/**
 * VersionParams contain the version of specific components of CometBFT.
 *
 * @generated from message cometbft.types.v1.VersionParams
 */
export class VersionParams extends Message<VersionParams> {
  /**
   * The ABCI application version.
   *
   * It was named app_version in CometBFT 0.34.
   *
   * @generated from field: uint64 app = 1;
   */
  app = protoInt64.zero;

  constructor(data?: PartialMessage<VersionParams>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.types.v1.VersionParams";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "app", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VersionParams {
    return new VersionParams().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VersionParams {
    return new VersionParams().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VersionParams {
    return new VersionParams().fromJsonString(jsonString, options);
  }

  static equals(a: VersionParams | PlainMessage<VersionParams> | undefined, b: VersionParams | PlainMessage<VersionParams> | undefined): boolean {
    return proto3.util.equals(VersionParams, a, b);
  }
}

/**
 * HashedParams is a subset of ConsensusParams.
 *
 * It is hashed into the Header.ConsensusHash.
 *
 * @generated from message cometbft.types.v1.HashedParams
 */
export class HashedParams extends Message<HashedParams> {
  /**
   * @generated from field: int64 block_max_bytes = 1;
   */
  blockMaxBytes = protoInt64.zero;

  /**
   * @generated from field: int64 block_max_gas = 2;
   */
  blockMaxGas = protoInt64.zero;

  constructor(data?: PartialMessage<HashedParams>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.types.v1.HashedParams";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "block_max_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "block_max_gas", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): HashedParams {
    return new HashedParams().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): HashedParams {
    return new HashedParams().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): HashedParams {
    return new HashedParams().fromJsonString(jsonString, options);
  }

  static equals(a: HashedParams | PlainMessage<HashedParams> | undefined, b: HashedParams | PlainMessage<HashedParams> | undefined): boolean {
    return proto3.util.equals(HashedParams, a, b);
  }
}

/**
 * SynchronyParams determine the validity of block timestamps.
 *
 * These parameters are part of the Proposer-Based Timestamps (PBTS) algorithm.
 * For more information on the relationship of the synchrony parameters to
 * block timestamps validity, refer to the PBTS specification:
 * https://github.com/tendermint/spec/blob/master/spec/consensus/proposer-based-timestamp/README.md
 *
 * @generated from message cometbft.types.v1.SynchronyParams
 */
export class SynchronyParams extends Message<SynchronyParams> {
  /**
   * Bound for how skewed a proposer's clock may be from any validator on the
   * network while still producing valid proposals.
   *
   * @generated from field: google.protobuf.Duration precision = 1;
   */
  precision?: Duration;

  /**
   * Bound for how long a proposal message may take to reach all validators on
   * a network and still be considered valid.
   *
   * @generated from field: google.protobuf.Duration message_delay = 2;
   */
  messageDelay?: Duration;

  constructor(data?: PartialMessage<SynchronyParams>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.types.v1.SynchronyParams";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "precision", kind: "message", T: Duration },
    { no: 2, name: "message_delay", kind: "message", T: Duration },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SynchronyParams {
    return new SynchronyParams().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SynchronyParams {
    return new SynchronyParams().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SynchronyParams {
    return new SynchronyParams().fromJsonString(jsonString, options);
  }

  static equals(a: SynchronyParams | PlainMessage<SynchronyParams> | undefined, b: SynchronyParams | PlainMessage<SynchronyParams> | undefined): boolean {
    return proto3.util.equals(SynchronyParams, a, b);
  }
}

/**
 * FeatureParams configure the height from which features of CometBFT are enabled.
 *
 * @generated from message cometbft.types.v1.FeatureParams
 */
export class FeatureParams extends Message<FeatureParams> {
  /**
   * First height during which vote extensions will be enabled.
   *
   * During the specified height, and for all subsequent heights, precommit
   * messages that do not contain valid extension data will be considered
   * invalid. Prior to this height, or when this height is set to 0, vote
   * extensions will not be used or accepted by validators on the network.
   *
   * Once enabled, vote extensions will be created by the application in
   * ExtendVote, validated by the application in VerifyVoteExtension, and
   * used by the application in PrepareProposal, when proposing the next block.
   *
   * Cannot be set to heights lower or equal to the current blockchain height.
   *
   * @generated from field: google.protobuf.Int64Value vote_extensions_enable_height = 1;
   */
  voteExtensionsEnableHeight?: bigint;

  /**
   * Height at which Proposer-Based Timestamps (PBTS) will be enabled.
   *
   * From the specified height, and for all subsequent heights, the PBTS
   * algorithm will be used to produce and validate block timestamps. Prior to
   * this height, or when this height is set to 0, the legacy BFT Time
   * algorithm is used to produce and validate timestamps.
   *
   * Cannot be set to heights lower or equal to the current blockchain height.
   *
   * @generated from field: google.protobuf.Int64Value pbts_enable_height = 2;
   */
  pbtsEnableHeight?: bigint;

  constructor(data?: PartialMessage<FeatureParams>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.types.v1.FeatureParams";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "vote_extensions_enable_height", kind: "message", T: Int64Value },
    { no: 2, name: "pbts_enable_height", kind: "message", T: Int64Value },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): FeatureParams {
    return new FeatureParams().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): FeatureParams {
    return new FeatureParams().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): FeatureParams {
    return new FeatureParams().fromJsonString(jsonString, options);
  }

  static equals(a: FeatureParams | PlainMessage<FeatureParams> | undefined, b: FeatureParams | PlainMessage<FeatureParams> | undefined): boolean {
    return proto3.util.equals(FeatureParams, a, b);
  }
}

/**
 * ABCIParams is deprecated and its contents moved to FeatureParams
 *
 * @generated from message cometbft.types.v1.ABCIParams
 * @deprecated
 */
export class ABCIParams extends Message<ABCIParams> {
  /**
   * vote_extensions_enable_height has been deprecated.
   * Instead, use FeatureParams.vote_extensions_enable_height.
   *
   * @generated from field: int64 vote_extensions_enable_height = 1;
   */
  voteExtensionsEnableHeight = protoInt64.zero;

  constructor(data?: PartialMessage<ABCIParams>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "cometbft.types.v1.ABCIParams";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "vote_extensions_enable_height", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ABCIParams {
    return new ABCIParams().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ABCIParams {
    return new ABCIParams().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ABCIParams {
    return new ABCIParams().fromJsonString(jsonString, options);
  }

  static equals(a: ABCIParams | PlainMessage<ABCIParams> | undefined, b: ABCIParams | PlainMessage<ABCIParams> | undefined): boolean {
    return proto3.util.equals(ABCIParams, a, b);
  }
}

